
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop, Watch } from 'vue-property-decorator';
import DispensaMedicaService from "@/service/v1/sigap/DispensaMedicaService"

@Options({
    name: "DispensaMedicaEditar",
    components: { Multiselect, BotaoSalvar },
    emits: ['dispensa-medica-alterada'],
})
export default class DispensaMedicaEditar extends Vue {
    @Prop() readonly modal!: any
    @Prop() readonly perfis!: any
    @Prop() readonly modelo!: any

    public service = new DispensaMedicaService();
    public processando = false;
    public titulo = 'Atualizar Dispensa Medica';

    public id: any = null;
    public inicio: any = null;
    public fim: any = null;
    public status_id: any = null;
    public status: any = null;

    async created() {
        this.getStatus();
    }

    @Watch('modelo')
    public modeloAlterado() {
        if (!this.modelo || !this.modelo.id) {
            return;
        }
        this.processando = true;
        this.service.getModel(this.modelo.id)
            .then(response => {
                this.id = response.id;
                this.inicio = SiteUtils.formatDataToPadrao(response.inicio);
                this.fim = SiteUtils.formatDataToPadrao(response.fim);
                this.status_id = response.status?.id;
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Error!', error.data.message);
            });
    }

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => { return { value: item.id, label: item.nome } });
        }
        return null;
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
            });
    }

    public getdados() {
        let dados: any = {};
        dados.id = this.id;
        dados.inicio = this.inicio;
        dados.fim = this.fim;
        dados.status = this.status_id;
        dados.matriculaId = this.modelo.matriculaid; 
        return dados;
    }

    public sucesso() {
        this.$emit("dispensa-medica-alterada", null);
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public salvar() {
        if (this.processando || !this.hasPermissao) {
            return;
        }
        if (!this.id || !this.inicio || !this.fim || !this.status_id) {
            SiteUtils.toastErro('Error!', 'Preencha inicio, fim e status.');
            return;
        }
        this.processando = true;
        let dados = this.getdados();
        setTimeout(() => {
            this.service.update(this.id, dados)
                .then(response => {
                    SiteUtils.toastSucesso('Atualizado com sucesso!', response.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
